import {useLocation} from 'react-router-dom';

const useQuerySearch = (queryKey: string) => {
  const search = useLocation().search;
  return new URLSearchParams(search).get(queryKey);
};

export default useQuerySearch;
